<div class="surveyContainer">
    <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
    <span class="sr-only">Loading...</span>
    <div class="header hdr">
        <h5><span class="animateH5">Survey Feedback</span></h5>
    </div>
    <div class="container-fluid text-record-main">
        <div class="table-responsive">
            <div class="card tblCrd">
                <table class="table table-hover text-center">
                    <thead class="tblHead ">
                        <tr class="text-center">
                            <th class="text-start">Client Code</th>
                            <th>User Id</th>
                            <th>Intake Number</th>
                            <th>Line Of Business</th>
                            <th>Comments OR Suggestion</th>
                            <th>Sentiment</th>
                            <th>Reason</th>
                           
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngIf="feedBackDataList.length > 0 else emptData">
                            <ng-container *ngFor="let items of feedBackDataList">
                                <tr>
                                    <td>{{items['CLAIM_NUMBER']}}</td>
                                    <td>{{items['USER_ID']}}</td>
                                    <td>{{items['INTAKE_NUMBER']}}</td>
                                    <td>{{items['LINE_OF_BUSINESS']}}</td>
                                    <td>{{items['COMMENTS_OR_SUGGESTION']}}</td>
                                    <!-- <td>{{items['SENTIMENT']}}</td> -->
                                    <td>
                                        <ng-container [ngSwitch]="items['SENTIMENT']">
                                            <ng-container *ngSwitchCase="'Neutral'">
                                              <i class="fa-regular fa-face-meh audioIcons iconMeh"></i>
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'Positive'">
                                           <i class="fa-regular fa-face-smile audioIcons iconSmile"></i>
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'Negative'">
                                                <i  class="fa-regular fa-face-frown audioIcons iconSad"></i>
                                            </ng-container>
                                      </ng-container>
                                    </td>
                                    <!-- <td>{{items['ISSUE_CATEGORY']}}</td> -->
                                   <td> <i class="fa fa-file-text audioIcons iconFile" data-bs-toggle="modal"
                                    data-bs-target="#transcriptModal" tooltip="View Reason" [options]="myOptions"
                                     
                                    (click)="getFeedback(items)"></i></td>
                                    
                                </tr>
                            </ng-container>
                        </ng-container>

                        <ng-template #emptData>
                         
                          <!-- <td>  <i class="fa fa-file-text audioIcons iconFile" data-bs-toggle="modal"
                                    data-bs-target="#transcriptModal" tooltip="View Transcript" [options]="myOptions"
                                     
                                    (click)="getFeedback()"></i>
                                </td> -->
                            <td colspan="7"><p>No Records Found</p></td>
                        </ng-template>
                    </tbody>
                </table>
            </div>
        </div>                
    </div>


      <!-- Modal window -->
      <div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="transcriptModal">
        <div class="modal-dialog modal-dialog-scrollable {{modalScreenSize}} modal-xl transcriptModalWindow">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title"> Reason</h4>
                    <div class="modal-header-second-part">
                      
                        <i class="fa-solid fa-up-right-and-down-left-from-center min-max-icon" title="Full Screen"
                            *ngIf="!modalScreenSize" (click)="modalFullScreen('max')"></i>
                        <i class="fa-solid fa-down-left-and-up-right-to-center min-max-icon" title="Restore Down"
                            *ngIf="modalScreenSize" (click)="modalFullScreen('min')"></i>
                        <i class="fa-solid fa-xmark exitIcon close " title="Close"
                            (click)="clearKeywordDetailsTranscriptModal()" data-bs-dismiss="modal"
                            aria-label="Close"></i>
                    </div>
                </div>
                <div class="modal-body" style="padding:15px;">
                 <div class="transcriptTab" style="border: 1px solid #ccc;
                 padding: 10px 10px;
                 background-color: #f5f5f5;">{{reasonData}}</div>
                </div>
            </div>
        </div>
    </div>
</div>     
